// extracted by mini-css-extract-plugin
module.exports = {"graphic":"FAQBox_graphic_1HDHh"};